var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"btn",class:[
        ("btn--" + _vm.resolvedVariant),
        ("btn--" + _vm.resolvedSize),
        { 'btn--gradient': _vm.resolvedGradient, 'btn--full': _vm.fullWidth, 'disabled': _vm.disabled }
    ],on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.loading)?_c('span',{staticClass:"btn__spinner",attrs:{"aria-label":"loading"}}):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }